
import { VuexModule, Module, Mutation, Action } from 'vuex-module-decorators';
import FractionDsn from '@/extend/classes/FractionDsn';
import { ColumnConfig } from '@/extend/classes/ListData';

@Module({ name: 'storeFractionDsn' })

export default class storeFractionDsn extends VuexModule {
  // States
  private data: FractionDsn[] = [];
  private config : ColumnConfig[] = [];
  
  public get fractionDsnLoaded (): boolean {
    return true;
  }
  public get getFractionDsn () {
    return (id: number): FractionDsn => {
      const res = this.data.find(c => c.id == id);
      if (res != undefined) {
        return res;
      } else {
        const copy = new FractionDsn();
        if (id == 0) {
          if (this.data.length == 0) {
            copy.id = -1;
          } else {
            this.data.sort((a, b) => (a.id - b.id));
            copy.id = Math.min(-1, this.data[0].id - 1);
          }
          this.data.push(copy);
        }
        return copy
      }
    }
  }

  public get listFractionDsn (): FractionDsn[] {
    return this.data;
  }

  public get listConfigFractionDsn (): ColumnConfig[] {
    return this.config;
  }

  @Mutation
  public mFractionDsnClearData (): void {
    this.data = [];
  }

  @Mutation
  public mFractionDsnLoaded (objs: FractionDsn[]): void {
    this.data = [];
    objs.forEach((obj) => {
      this.data.push(obj);
    });
  }

  @Mutation
  public mFractionDsnUpdated (obj: FractionDsn): void {
    const api = this.data.find(x => x.id == obj.id);
    if (api != null) {
      api.fromFractionDsn(obj);
    }
  }

  @Mutation
  public mFractionDsnDeleted (id: number): void {
    const index = this.data.findIndex(x => x.id == id);
    if (index >= 0) {
      this.data.splice(index, 1);
    }
  }

  @Action
  public registerFractionDsn (): Promise<boolean> {
    return new Promise((resolve) => {
      resolve(true);
    })
  }

  @Action
  public updateFractionDsn (obj: FractionDsn): Promise<FractionDsn> {
    return new Promise((resolve) => {
        this.mFractionDsnUpdated(obj);
        resolve(obj)
    })
  }

  @Action
  public deleteFractionDsn (obj: FractionDsn): Promise<boolean> {
    return new Promise((resolve) => {
        this.mFractionDsnDeleted(obj.id) 
        resolve(true);
    })
  }
}
